import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from '../CoroutineDispatcher.mjs';
import { Delay9umexudtwyie as Delay } from '../Delay.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { get_DefaultDelay3q9fawcutqbnw as get_DefaultDelay } from '../CoroutineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedDispatcherClass;
function NamedDispatcher() {
  if (NamedDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor(dispatcher, name) {
        super();
        var tmp = this;
        var tmp0_elvis_lhs = isInterface(dispatcher, Delay()) ? dispatcher : null;
        tmp.u1j_1 = tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
        this.v1j_1 = dispatcher;
        this.w1j_1 = name;
      }
      r12(context) {
        return this.v1j_1.r12(context);
      }
      u12(context, block) {
        return this.v1j_1.u12(context, block);
      }
      toString() {
        return this.w1j_1;
      }
      i13(timeMillis, continuation) {
        this.u1j_1.i13(timeMillis, continuation);
      }
      j13(timeMillis, block, context) {
        return this.u1j_1.j13(timeMillis, block, context);
      }
    }
    initMetadataForClass($, 'NamedDispatcher', VOID, VOID, [Delay()], [1]);
    NamedDispatcherClass = $;
  }
  return NamedDispatcherClass;
}
//region block: exports
export {
  NamedDispatcher as NamedDispatcher2rg47sbefduxc,
};
//endregion

//# sourceMappingURL=NamedDispatcher.mjs.map
